import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-button-bar-container", class: {
    ["mp-button-bar-".concat(this.attr("theme"))]: true,
    "mp-button-bar-is-disabled": this.attr("disabled")
  }, attrs: {
    elref: "buttonBarContainer"
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-button-bar-content-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".mp-button-bar-content" }, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" })), this.attr("arrow-next") ? /* @__PURE__ */ jsx("div", { sel: ".mp-button-bar-arrow-next" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "arrow-right"
  } })) : null));
}
